<template>
  <div class="main-cont">
    <div class="container">
      <div class="wages">
        <div class="banner">
          <div class="box">
            <h1>
              کارمزد ها و هزینه خدمات
            </h1>

            <p>
              کارمزد معاملات سایت به صورت درصد از مبلغ کل معامله است و محاسبه آن بر اساس ملاحظات زیر صورت می گیرد:
            </p>
<!--            <p>-->
<!--              کارمزد معاملات بامبو به صورت درصد از مبلغ کل معامله است و محاسبه آن بر اساس ملاحظات زیر صورت می گیرد:-->
<!--            </p>-->
<!--            <p>-->
<!--              کارمزد معاملات بامبو به صورت درصد از مبلغ کل معامله است و محاسبه آن بر اساس ملاحظات زیر صورت می گیرد:-->
<!--            </p>-->

          </div>
<!--          <img src="../../assets/public/wages.png">-->
        </div>
        <div class="user-levels">
          <p>سطوح کاربری</p>
          <div class="level-table">
            <table>
              <thead>
              <tr>
                <th>سطح کاربری</th>
                <th>میزان معامله در سه ماه اخیر</th>
                <th>کارمزد</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item,index) in level" :key="index">
                <td class="text-center">{{ $levels[item.userAccountLevel] }} سطح</td>
                <td class="text-center">{{ `بیشتر از ${$toLocal(item.tradeAmount,$decimal['TOMAN'])}` }}</td>
                <td class="text-center">%{{ item.wagePercent }}</td>
              </tr>

              </tbody>
            </table>
          </div>
        </div>
        <div class="user-wage">
          <p>کارمزد برداشت ارزها</p>
          <div class="wage-table">
            <table>
              <thead>
              <tr>
                <th>نوع ارز</th>
                <th>حداقل میزان قابل برداشت</th>
                <th>کارمزد</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item,index) in detail" :key="index">
                <td class="text-center">{{ item.persianName }}</td>
                <td class="text-center">{{ item.tokenTypeDetails[0].minWithdraw  }}</td>
                <td class="text-center">{{ item.tokenTypeDetails[0].withdrawalFee }}</td>
              </tr>

              </tbody>
            </table>
          </div>
        </div>
        <div class="wage-rules">
          <p>کارمزد برداشت ریالی</p>
          <div class="box">
            <p>برداشت‌های ریالی برای تمامی حساب‌ها، در قالب انتقال پایا و یک بار در روز خواهد بود. بدیهی است مدت زمان
              انجام تسویه ریالی، بسته به زمان درخواست برداشت، در روزهای غیر تعطیل می‌تواند حداکثر تا ۲۴ ساعت به طول
              انجامد.</p>
          </div>
        </div>
      </div>
    </div>
<!--    <FooterComponent/>-->
  </div>
</template>

<script>
// import FooterComponent from "@/components/sharing-components/footer";
export default {
  components: {
    // FooterComponent
  },
  data() {
    return {
      level:[],
      detail:[],
      levels: [
        {
          level: 'سطح کاربری ۱',
          amount: 'کمتر از ۲۰ میلیون تومان',
          wage: '۰.۴٪',
        },
        {
          level: 'سطح کاربری ۱',
          amount: 'کمتر از ۲۰ میلیون تومان',
          wage: '۰.۴٪',
        },
        {
          level: 'سطح کاربری ۱',
          amount: 'کمتر از ۲۰ میلیون تومان',
          wage: '۰.۴٪',
        },
        {
          level: 'سطح کاربری ۱',
          amount: 'کمتر از ۲۰ میلیون تومان',
          wage: '۰.۴٪',
        },
        {
          level: 'سطح کاربری ۱',
          amount: 'کمتر از ۲۰ میلیون تومان',
          wage: '۰.۴٪',
        },
        {
          level: 'سطح کاربری ۱',
          amount: 'کمتر از ۲۰ میلیون تومان',
          wage: '۰.۴٪',
        },


      ],
      wages: [
        {
          coin: 'بیت کوین',
          amount: '۰.۱BTC',
          wage: '۰.۱BTC',
        },
        {
          coin: 'بیت کوین',
          amount: '۰.۱BTC',
          wage: '۰.۱BTC',
        },
        {
          coin: 'بیت کوین',
          amount: '۰.۱BTC',
          wage: '۰.۱BTC',
        },
        {
          coin: 'بیت کوین',
          amount: '۰.۱BTC',
          wage: '۰.۱BTC',
        },
        {
          coin: 'بیت کوین',
          amount: '۰.۱BTC',
          wage: '۰.۱BTC',
        },
        {
          coin: 'بیت کوین',
          amount: '۰.۱BTC',
          wage: '۰.۱BTC',
        },
        {
          coin: 'بیت کوین',
          amount: '۰.۱BTC',
          wage: '۰.۱BTC',
        },
        {
          coin: 'بیت کوین',
          amount: '۰.۱BTC',
          wage: '۰.۱BTC',
        },
        {
          coin: 'بیت کوین',
          amount: '۰.۱BTC',
          wage: '۰.۱BTC',
        },
        {
          coin: 'بیت کوین',
          amount: '۰.۱BTC',
          wage: '۰.۱BTC',
        },
        {
          coin: 'بیت کوین',
          amount: '۰.۱BTC',
          wage: '۰.۱BTC',
        },

      ]
    }
  },
  methods:{
    async getLevels(){
      const levels = await this.$axios('/users/account-levels')
      this.level = levels

    },
    async getCoinsDetails(){
      const details = await this.$axios('/coins/details?p2pSupported=true')
      this.detail = details.content

    }
  },
  mounted() {
    this.getLevels()
    this.getCoinsDetails()
  }
};

</script>

<style lang="scss" scoped>
.container {
color: white;
  display: flex;
  background-image: url(../assets/backgrounds/about.png);
  position: center;
  background-size: cover;
  background-repeat: no-repeat;

}

.wages {
  display: flex;
  flex-direction: column;
  row-gap: 60px;
  padding: 10px 20px;
  width: 100%;
  justify-content: space-between;
  align-items: center;

  .banner {
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    gap: 20px;


    .box {
      //margin-top: 85px;
      display: flex;
      justify-content: center;
      //padding: 60px 80px;
      flex-direction: column;
      row-gap: 24px;



      //background: #141B31;


      h1 {
        font-size: clamp(20px, 2vw, 40px);
        //color: #FEBC00;
      }
    }
  }

  .user-levels {
    //align-self: flex-start;
    //display: flex;
    flex-direction: column;
    row-gap: 28px;
    width: 100%;

    > p {
      display: flex;
      align-self: flex-start;
      font-size: clamp(18px, 1vw, 24px);
      //color: #FEBC00;
    }

    .level-table {
      padding: 10px;
      width: 100%;
      //background-color: #141B31;
      border-radius: 16px;

      table {
        width: 100%;
        border-collapse: collapse;
        table-layout: fixed;

        thead {
          tr {
            th {
              padding: 40px 0px;
              font-size: clamp(16px, 1vw, 18px);
            }
          }
        }

        tbody {
          tr {
            height: 80px;
            border-bottom: 1px solid white;
          }

          tr:last-child {
            border-bottom: none;
          }
        }
      }

    }
  }

  .user-wage {
    //display: flex;
    flex-direction: column;
    row-gap: 28px;
    width: 100%;

    > p {
      //display: flex;
      //align-self: flex-start;
      font-size: clamp(18px, 1vw, 24px);
      //color: #FEBC00;
    }

    .wage-table {
      padding: 10px;
      width: 100%;
      //background-color: #141B31;
      border-radius: 16px;

      table {
        width: 100%;
        border-collapse: collapse;
        table-layout: fixed;

        thead {
          tr {
            th {
              padding: 40px 0px;
              font-size: clamp(16px, 1vw, 18px);
            }
          }
        }

        tbody {
          tr {
            height: 80px;
            border-bottom: 1px solid white;
          }

          tr:last-child {
            border-bottom: none;
          }
        }
      }

    }
  }

  .wage-rules {
    margin-bottom: 96px;
    align-self: flex-start;
    display: flex;
    flex-direction: column;
    row-gap: 28px;
    width: 100%;

    > p {
      display: flex;
      align-self: flex-start;
      font-size: clamp(18px, 1vw, 24px);
      //color: #FEBC00;
    }

    .box {
      padding: 30px 0;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: #141B31;
      border-radius: 16px;
      width: 100%;
      >p{
        max-width: 986px;
      }

    }
  }
}
@media screen and (max-width: 600px) {
  .wages {
    .wage-rules{
      margin-bottom: 10px;
      .box{
        padding: 10px;
      }
    }
    .banner{
      .box{
        margin-top: 10px;
        min-height: 100%;
        padding: 10px;
      }

      >img{
        display: none;
      }
    }
  }



}
</style>
